import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { BOOSTERS_PRESENTATION_ROUTES } from '#modules/boosters/routes/boosters-presentation.routing';
import { TOTEMS_ROUTES } from '#modules/nfcs/routes/totems.routing';
import { LOGGED_IN_WHEELS_OF_FORTUNE_ROUTES } from '#modules/wheels-of-fortune/routes/logged-in-wheels-of-fortune.routing';

export const BOOSTERS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/boosters-layout/boosters-layout.component').then(
                (m) => m.BoostersLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'totems',
            },
            {
                path: 'presentation',
                loadChildren: () => BOOSTERS_PRESENTATION_ROUTES,
                data: { routePath: RoutePath.BOOSTERS_PRESENTATION },
            },
            {
                path: 'wheels-of-fortune',
                loadChildren: () => LOGGED_IN_WHEELS_OF_FORTUNE_ROUTES,
                data: { routePath: RoutePath.WHEEL_OF_FORTUNE },
            },
            {
                path: 'totems',
                loadChildren: () => TOTEMS_ROUTES,
                data: { routePath: RoutePath.TOTEMS },
            },
        ],
    },
];
